<img *ngIf="preview.image" src="{{ preview.image }}" class="preview-image" (click)="openDetails()">
<p class="preview-text" (click)="openDetails()">{{ preview.text }}</p>
<!-- <div class="preview-text" (click)="openDetails()" [innerHTML]="preview.text|safe:'html'"></div> -->
